import { Application } from "@hotwired/stimulus"

import CheckboxSubmitController from "./checkbox_submit_controller"
import CollapsibleController from "./collapsible_controller"
import CostCalculatorController from "./cost_calculator_controller"
import FillDownController from "./fill_down_controller"
import ItemCostCalculatorController from "./item_cost_calculator_controller"
import IntervalSelectController from "./interval_select_controller"
import ToggleSectionsController from "./toggle_sections_controller"
import TreeRowController from "./tree_row_controller"

const application = Application.start()
application.register("checkbox-submit", CheckboxSubmitController)
application.register("collapsible", CollapsibleController)
application.register("cost-calculator", CostCalculatorController)
application.register("fill-down", FillDownController)
application.register("item-cost-calculator", ItemCostCalculatorController)
application.register("interval-select", IntervalSelectController)
application.register("toggle-sections", ToggleSectionsController)
application.register("tree-row", TreeRowController)
